import { useZero } from "@rocicorp/zero/react";
import { sharedMutators } from "../../../../shared/mutators";
import { Button } from "../../Button";
import { ConfirmModal } from "../../ConfirmModal";
import { Modal } from "../../Modal";
import { Text } from "../../Text";
import { CopyableValue } from "../CopyableValue";
import { ModalContent, ModalFooter } from "../shared";

export function ScimTokenModal({
  token,
  onClose,
}: {
  token: string | null;
  onClose: () => void;
}) {
  if (!token) return null;
  return (
    <Modal open onClose={onClose}>
      <ModalContent>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Text variant="text-regular-md">SCIM token created</Text>
          <Text variant="text-regular" color="var(--text-secondary)">
            Copy this token now — it won’t be shown again.
          </Text>
        </div>
        <CopyableValue value={token}>
          <Text
            variant="text-regular"
            color="var(--text-secondary)"
            style={{ flex: 1 }}
          >
            {token}
          </Text>
        </CopyableValue>
        <ModalFooter>
          <Button size="l" onClick={onClose}>
            Done
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export function RevokeSessionsModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const z = useZero();
  return (
    <ConfirmModal
      open={open}
      onClose={onClose}
      onConfirm={() => {
        z.mutate(sharedMutators.revokeAllSessions({}));
        onClose();
      }}
      title="Revoke all sessions"
      description="All other users will be signed out and must re-authenticate. Your current session will not be affected — sign out manually if you also need to re-authenticate."
      confirmLabel="Revoke all"
      destructive
    />
  );
}
